export default __webpack_public_path__ + "18dcad164f57ed936097526a4f69ea55.png";